export const ADMIN_MERCHANT_ENDPOINT = "/admin/merchant";
export interface AdminMerchant {
  createdAt: string;
  createdBy: string;
  deletedAt: string;
  email: string;
  id: string;
  name: string;
  password: string;
  phoneNumber: string;
  updatedAt: string;
  updatedBy: string;
  username: string;
  version: number;
}
